module.exports = __webpack_public_path__ + "assets/img/ranking-title.c4eee184.png";